/**
 * Determines if a guest user's email is "external" — i.e., NOT from an internal
 * corporate domain. External guests get a drastically simplified sidebar.
 *
 * Internal domains:
 *  - @vepormas.com
 *  - @segurosvepormas.com
 *  - @cincel.digital
 */

const INTERNAL_DOMAINS = [
    'vepormas.com',
    'segurosvepormas.com',
    'cincel.digital',
];

/**
 * Returns true if the email does NOT belong to any internal corporate domain.
 * A null/undefined email is treated as external.
 */
export function isExternalVepormasGuest(email: string | null | undefined): boolean {
    if (!email) return true;
    const domain = email.split('@')[1]?.toLowerCase();
    if (!domain) return true;
    return !INTERNAL_DOMAINS.some((d) => domain === d);
}
